/**
 * @deprecated This component has been replaced by `AssemblyScaleScreen` as
 * part of the `ScaleContainer` implementation. It is kept temporarily for
 * backwards-compatibility and will be removed in a future tech debt cleanup.
 */
import { Add as AddIcon } from '@mui/icons-material';

import { AssemblyScreenProps } from './AssemblyScreen.interface';
import {
  AssemblyScreenContainer,
  AssemblyScreenEditIconContainer,
} from './AssemblyScreen.styled';

export const AssemblyScreen = (props: AssemblyScreenProps) => {
  return (
    <AssemblyScreenContainer
      width={props.width}
      height={props.height}
      $selectable={props.selectable}
      $scale={props.scale}
      $type={props.type}
      $isSelected={props.isSelected}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      data-testid="assembly-screen"
      onClick={props.selectable ? props.onClick : undefined}>
      {props.children}

      {props.showEditIcon && props.selectable && (
        <AssemblyScreenEditIconContainer>
          <AddIcon />
        </AssemblyScreenEditIconContainer>
      )}
    </AssemblyScreenContainer>
  );
};
